import { mapGetters, mapMutations } from "vuex";
import config from "../assets/config";
export const proyecto = {
  beforeMount() {},
  mounted() {
    this.cargarColores(this.proyecto_v, "before");
  },
  computed: {
    ...mapGetters(["getStateCookie", "getStateData", "proyecto_v", "url_logo", "substates", "substates_config"]),
  },
  watch: {
    proyecto_v: {
      handler(newVal) {
        this.cargarColores(newVal, "wath");
      },
      deep: true,
    },
  },
  data() {
    return {
      pv_id: null,
    };
  },
  methods: {
    ...mapMutations(["setStateData"]),

    cargarColores(colors, or) {
      this.$vuetify.theme.primary = colors.primary ? colors.primary : "#03A9F4";
      this.$vuetify.theme.secondary = colors.secondary ? colors.secondary : "#757575";
      this.$vuetify.theme.accent = colors.accent ? colors.accent : "#607D8B";
      this.$vuetify.theme.text = colors.text ? colors.text : "#212121";
    },
  },
};
